<template>
	<CModal
		:show.sync="isShow"
		:close-on-backdrop="false"
		centered
		class="modal-confirm-delete"
	>
		<template #header-wrapper>
			<ModalHeaderWrapper
				:title="title"
				@onClose="handleCancel"
			/>
		</template>
		<template #footer>
			<CButton
				color="tertiary"
				class="mr-3"
				@click="handleCancel"
			>
				Cancel
			</CButton>
			<CButton
				:disabled="disabledSubmit"
				color="danger"
				@click="handleSubmit"
			>
				Remove
			</CButton>
		</template>
	</CModal>
</template>

<script>
export default {
	props: {
		show: {
			type: Boolean,
			default: null,
		},
		title: {
			type: String,
			default: null,
		},
		disabledSubmit: {
			type: Boolean,
			default: false,
		},
	},

	data() {
		return {
			isShow: false,
		};
	},

	computed: {
		isCustmToggle() {
			return this.show !== null;
		},
	},

	watch: {
		show() {
			this.isShow = this.show;
		},
		isShow() {
			this.$emit('update:show', this.isShow);
		},
	},

	created() {
		this.isShow = this.show;
	},

	methods: {
		open() {
			this.isShow = true;
		},
		close() {
			this.isShow = false;
		},
		handleSubmit() {
			this.$emit('onSubmit');

			if (!this.isCustmToggle) {
				this.close();
			}
		},
		handleCancel() {
			this.$emit('onCancel');

			if (!this.isCustmToggle) {
				this.close();
			}
		},
	},
};
</script>

<style lang="scss" scoped>
::v-deep .modal-dialog {
	max-width: rem(500);
}
</style>
